export default "__VITE_ASSET__a12baa57__"